import type { Callout } from '@rover/types/src/Callout';
import { CalloutSlugs } from '@rover/types/src/Callout';

type CalloutBySlug<S extends CalloutSlugs> = Extract<Callout, { slug: `${S}` }>;

export const getCallout = <S extends CalloutSlugs>(
  searchCallouts: Callout[] | undefined,
  slug: S
): CalloutBySlug<S> | undefined =>
  searchCallouts?.find((callout): callout is CalloutBySlug<S> => callout.slug === slug);
